import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#1e1f4a] text-white py-16">
            <div className="max-w-[1280px] mx-auto px-4 sm:px-10">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    {/* Brand Section */}
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-3">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/COMSATS_new_logo.jpg/770px-COMSATS_new_logo.jpg"
                                alt="COMSATS Logo"
                                className="h-10 w-auto object-contain bg-white rounded-md p-0.5"
                            />
                            <h2 className="text-xl font-bold tracking-tight text-white">COMSATS Past Papers</h2>
                        </div>
                        <p className="text-gray-200 text-sm leading-relaxed">
                            The unofficial academic repository for COMSATS students. Providing study materials since 2018.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-gray-300">
                            Quick Links
                        </h3>
                        <ul className="flex flex-col gap-2 text-sm text-gray-200">
                            <li>
                                <Link to="/browse" className="text-gray-200 hover:text-white transition-colors">
                                    Search Papers
                                </Link>
                            </li>
                            <li>
                                <Link to="/browse" className="text-gray-200 hover:text-white transition-colors">
                                    By Department
                                </Link>
                            </li>
                            <li>
                                <Link to="/browse" className="text-gray-200 hover:text-white transition-colors">
                                    By Semester
                                </Link>
                            </li>
                            <li>
                                <Link to="/resources" className="text-gray-200 hover:text-white transition-colors">
                                    Recommended Books
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* University Links */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-gray-300">
                            University
                        </h3>
                        <ul className="flex flex-col gap-2 text-sm text-gray-200">
                            <li>
                                <a
                                    href="https://portal.comsats.edu.pk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-200 hover:text-white transition-colors"
                                >
                                    CUI Portal
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.comsats.edu.pk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-200 hover:text-white transition-colors"
                                >
                                    Official Site
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://lms.comsats.edu.pk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-200 hover:text-white transition-colors"
                                >
                                    LMS Access
                                </a>
                            </li>
                            <li>
                                <a href="#" className="text-gray-200 hover:text-white transition-colors">
                                    Exam Schedule
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Connect Section */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-gray-300">
                            Connect
                        </h3>
                        <div className="flex gap-4">
                            <a
                                href="#"
                                className="bg-white/10 p-2 rounded-lg hover:bg-white/20 transition-colors"
                            >
                                <span className="material-symbols-outlined text-xl text-white">share</span>
                            </a>
                            <a
                                href="#"
                                className="bg-white/10 p-2 rounded-lg hover:bg-white/20 transition-colors"
                            >
                                <span className="material-symbols-outlined text-xl text-white">mail</span>
                            </a>
                            <a
                                href="#"
                                className="bg-white/10 p-2 rounded-lg hover:bg-white/20 transition-colors"
                            >
                                <span className="material-symbols-outlined text-xl text-white">forum</span>
                            </a>
                        </div>
                        <p className="text-xs text-gray-300 mt-2">
                            © {currentYear} COMSATS Past Papers. Not an official university entity.
                        </p>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-gray-300">
                        <Link to="/privacy" className="text-gray-200 hover:text-white transition-colors">
                            Privacy Policy
                        </Link>
                        {' · '}
                        <Link to="/terms" className="text-gray-200 hover:text-white transition-colors">
                            Terms of Service
                        </Link>
                        {' · '}
                        <Link to="/cookies" className="text-gray-200 hover:text-white transition-colors">
                            Cookie Policy
                        </Link>
                    </p>
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-green-500"></span>
                            <span className="text-xs text-gray-200">Server Status: Online</span>
                        </div>
                        <span className="text-xs text-gray-400">•</span>
                        <span className="text-xs text-gray-200">Version 1.1</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
